import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Table } from 'antd';
@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'sys-user',
  }
  componentDidMount() {
    const { sysStore: { init, getApp } } = this.props;
    init();
    getApp();
  }
  getColumns = () => {
    const { prefixCls, sysStore: { routing } } = this.props;
    return [
      { title: '应用名称', dataIndex: 's_name', key: 's_name', },
      { title: '应用编码', dataIndex: 's_number', key: 's_number', },
      { title: '开发者', dataIndex: 'm_name', key: 'm_name', },
      {
        title: '状态', dataIndex: 's_status', key: 's_status', render: (text) => {
          return text === '0' ? '创建应用'
            : text === '1' ? '发布应用'
              : text === '2' ? '平台审核'
                : text === '3' ? '发布成功'
                  : text === '4' ? '触发更新' : '异常流程';
        }
      },
      {
        title: '操作', dataIndex: 'op', key: 'op', render: (text, record) => { 
          return (<div className={`${prefixCls}-joinList-btn`}>
            <span onClick={() => routing.push(`/dev/${record.s_id}/show`)}>查看</span>
          </div>)
        }
      }
    ];
  }
  onTableChange = (current, pageSize) => {
    const { sysStore: { getApp, setMobxState } } = this.props;
    setMobxState({ current, pageSize });
    getApp({ current, pageSize });
  }
  render() {
    const { prefixCls, sysStore: { appList, appCount, loading, pageSize, current } } = this.props;
    return (
      <div className={`${prefixCls}`}>
        <Table
          rowKey="m_id"
          loading={loading}
          bordered={true}
          dataSource={toJS(appList)}
          columns={this.getColumns()}
          pagination={{
            total: appCount,
            pageSize: pageSize,
            current: current,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: total => (<span>共{total}条</span>),
            onChange: this.onTableChange,
            onShowSizeChange: (page, size) => this.onTableChange(1, size),
          }} />
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/app/DevApplyList.js